import { createSejfaRequest } from '../../api-definition';
import {
  RegisterFreeInsurancePaylinkRequest,
  RegisterFreeInsurancePaylinkResponse
} from './types';

export const registerFreeInsurancePaylink = createSejfaRequest<
  RegisterFreeInsurancePaylinkResponse,
  RegisterFreeInsurancePaylinkRequest
>({
  path: 'paylinks',
  method: 'POST'
});
